module.exports = __webpack_public_path__ + "img/山_mountain.a1555635.svg";